
import { defineComponent } from 'vue'
import IconBase from '@/vue/icons/IconBase.vue'

export default defineComponent({
  name: 'IconArrowAlt',
  components: {
    IconBase,
  },
})
